import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Select, Row, Col } from '@folio/stripes/components';
import { FormattedMessage } from 'react-intl';

function FavoritesFilter({ searchTerm, onSearchChange, selectedTag, onTagChange, availableTags }) {
  const tagOptions = [
    { value: '', label: 'All Tags' },
    ...availableTags.map(tag => ({ value: tag, label: tag }))
  ];

  return (
    <div style={{ padding: '1rem', backgroundColor: '#f8f9fa', marginBottom: '1rem' }}>
      <Row>
        <Col xs={8}>
          <TextField
            label={<FormattedMessage id="ui-reports.favorites.search" defaultMessage="Search" />}
            placeholder="Search by name or description..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            clearFieldId="clear-search"
            fullWidth
          />
        </Col>
        <Col xs={4}>
          <Select
            label={<FormattedMessage id="ui-reports.favorites.filterByTag" defaultMessage="Filter by Tag" />}
            dataOptions={tagOptions}
            value={selectedTag}
            onChange={(e) => onTagChange(e.target.value)}
            fullWidth
          />
        </Col>
      </Row>
    </div>
  );
}

FavoritesFilter.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  selectedTag: PropTypes.string.isRequired,
  onTagChange: PropTypes.func.isRequired,
  availableTags: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default FavoritesFilter;
